import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { useState } from 'react';

const articleLinks = [
  { slug: 'best-allchinabuy-spreadsheet', label: 'Best Spreadsheet 2026' },
  { slug: 'free-allchinabuy-spreadsheet', label: 'Free Spreadsheet Guide' },
  { slug: 'allchinabuy-spreadsheet-2026-guide', label: '2026 Resource Guide' },
  { slug: 'allchinabuy-yupoo-spreadsheet', label: 'Yupoo Integration' },
  { slug: 'allchinabuy-shoes-spreadsheet', label: 'Shoes Directory' },
  { slug: 'allchinabuy-clothing-spreadsheet', label: 'Clothing Directory' },
  { slug: 'allchinabuy-seller-spreadsheet', label: 'Seller Directory' },
  { slug: 'allchinabuy-trusted-sellers', label: 'Trusted Sellers' },
  { slug: 'allchinabuy-buying-guide', label: 'Buying Guide' },
  { slug: 'allchinabuy-safety-guide', label: 'Safety Guide' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setSubmitted(true);
      setEmail('');
      return;
    }

    if (!email.trim()) return;

    try {
      const body = new URLSearchParams();
      body.append('email', email.trim());
      await fetch('https://readdy.ai/api/form/d8uj9jf43hkdi0qge4b0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setSubmitted(true);
      setEmail('');
    }
  };

  return (
    <footer className="mx-4 md:mx-6 mb-4 md:mb-6">
      <div className="bg-foreground-950 rounded-3xl px-6 md:px-14 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1.5fr] gap-10 md:gap-16">
          <div>
            <h3 className="font-heading text-3xl md:text-4xl text-background-50 font-light mb-3">Stay Updated</h3>
            <p className="text-foreground-400 text-sm mb-8 leading-relaxed">
              Get notified when we add new spreadsheets, seller directories, and buying guides. No spam, just helpful resources.
            </p>
            {submitted ? (
              <p className="text-primary-400 text-sm font-medium">Thank you for subscribing! We will keep you posted.</p>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-3">
                <input
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="bg-transparent border-b border-foreground-600 py-2.5 text-sm text-background-50 placeholder:text-foreground-500 outline-none focus:border-primary-400 transition-colors"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="spam-guard"
                />
                <button
                  type="submit"
                  className="inline-flex items-center gap-2 bg-background-50 text-foreground-950 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer w-fit"
                >
                  Subscribe
                  <i className="ri-arrow-right-line text-sm"></i>
                </button>
              </form>
            )}
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-5 uppercase tracking-wider">Navigate</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Home</Link>
              <Link to="/allchinabuy-buying-guide/" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Shopping Guide</Link>
              <Link to="/allchinabuy-safety-guide/" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Safety Guide</Link>
              <a href="/#categories" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Categories</a>
              <Link to="/best-allchinabuy-spreadsheet/" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Best Spreadsheet 2026</Link>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-5 uppercase tracking-wider">SEO Guides</h4>
            <div className="grid grid-cols-2 gap-2">
              {articleLinks.map((link) => (
                <Link
                  key={link.slug}
                  to={`/${link.slug}`}
                  className="text-foreground-400 text-xs hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
            </div>
            <h4 className="text-background-50 text-sm font-semibold mb-3 mt-6 uppercase tracking-wider">Quick Categories</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-400 text-xs hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <Link to="/allchinabuy-safety-guide/" className="text-foreground-500 text-sm hover:text-background-50 transition-colors cursor-pointer">Privacy Policy</Link>
            <Link to="/allchinabuy-safety-guide/" className="text-foreground-500 text-sm hover:text-background-50 transition-colors cursor-pointer">Terms</Link>
            <Link to="/allchinabuy-safety-guide/" className="text-foreground-500 text-sm hover:text-background-50 transition-colors cursor-pointer">Disclaimer</Link>
          </div>
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} AllChinaBuy Codes. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}